import React, { Component } from 'react';
import Page from '../../components/Page/Page';
import SideImage from '../../components/SideImage/SideImage';
import SideBox from '../../components/SideBox/SideBox';
import LightboxTrigger from '../../components/LightboxTrigger/LightboxTrigger';
import NextPage from '../../components/NextPage/NextPage';

class PageTradeshowManagement extends Component {

  render() {

    //Data for sidebox lightbox
    const images = ["/images/sidebox/loading.jpg"];
    const captions = ["Saving shipping costs by loading a tractor trailer to the brim"];

    return (
      <Page primaryTitle="Services" secondaryTitle="Tradeshow Management" section="services">
          <div className="col-sm-8 col-sm-push-4 col-lg-9 col-lg-push-3 pageTradeshowManagement">
              <p className="intro">The logistics associated with attending a tradeshow can be a harrowing experience for even the most seasoned tradeshow manager. SLA Service Management can ease the burden, making your tradeshow attendance a painless, turnkey, and rather pleasant experience!</p>

              <h3>Labor</h3>
              <p>Long-standing, trusted relationships with the best labor sources all across the United States will ensure the efficient installation and dismantle of your exhibit. This will result in shortened labor calls and decreased labor invoices. SLA is also available to provide personal on-site supervision of the I&amp;D of your exhibit to ensure the best possible tradeshow experience. SLA will also manage the submission of all EAC forms to show management and the general contractor, along with labor coordination to ensure that their certificate of insurance has been submitted.</p>

              <h3>Service Orders</h3>
              <p>SLA Service Management can manage the placement of all general contractor and facility orders. SLA will also manage the submission of electrical, internet, and rigging placement diagrams to facility engineering. And, SLA will provide a copy of all submitted paperwork to you for review AND to labor to ensure they are aware of all installation requirements.</p>

              <h3>Shipping</h3>
              <p>SLA has developed trusted relationships with carriers most suited to the transport of your exhibit and will manage all shipment arrangements and paperwork associated with the transport of your exhibit. This management service includes split shipments, inbound and outbound labels and bill(s) of lading, customs paperwork, marshaling and targeted delivery arrangements as well as keeping a watchful eye over the entire shipment process to ensure transport and material handling costs are contained.</p>
          
              <NextPage page={this.props.page}/>
          </div>
          <aside className="col-sm-4 col-sm-pull-8 col-lg-3 col-lg-pull-9 sidebar">
              <SideImage page={this.props.page} />
              <SideBox title="Making it all fit">
                <LightboxTrigger 
                    buttonClass="transparent"
                    index={0}
                    images={images}
                    captions={captions}
                >
                  <img src="/images/sidebox/loading-sm.jpg" alt="" />
                </LightboxTrigger>
                <p className="caption">Jim's clever loading saved this client from requiring a second truck for their National Sales Meeting</p>
              </SideBox>
          </aside>
      </Page>
    );
  }
}

export default PageTradeshowManagement;



// WEBPACK FOOTER //
// ./src/pages/PageTradeshowManagement/PageTradeshowManagement.js